import React, { Component } from 'react'

import { formatISO } from 'date-fns'
import { Field, reduxForm } from 'redux-form/immutable'

import PrimaryButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/primaryButton/PrimaryButton'
import DateInputField from '@lyrahealth-inc/ui-core/lib/atoms/form/dateInputField/DateInputField'
import { SelectFieldRFF } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/formElements/SelectField'

import styles from './downloadCSVForm.module.scss'
import downloadCSVValidate from './downloadCSVValidate'

const paymentStatusOptions = ['Submitted', 'Approved', 'Rejected', 'Cancelled', 'T0', 'Reversed', 'All'].map(
  (status) => ({ label: status, value: status }),
)

type Props = {
  handleSubmit?: (...args: any[]) => any
  submitDownload?: (...args: any[]) => any
  submitting?: boolean
}
class DownloadCSVForm extends Component<Props> {
  render() {
    const { submitting, handleSubmit, submitDownload } = this.props

    return (
      // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      <form onSubmit={handleSubmit(submitDownload)}>
        <div className={'row'}>
          <div className={'col-xs-6 col-sm-6'}>
            <Field
              name='payment_status'
              component={SelectFieldRFF}
              label='Payment Status'
              options={paymentStatusOptions}
              placeholder='Select...'
            />
          </div>
        </div>
        <div className={`row ${styles['date-range']}`}>
          <div className={'col-xs-6 col-sm-6'}>
            <Field
              name='start_date'
              type='tel'
              component={DateInputField}
              showMonthDropdown
              showYearDropdown
              maxDate={formatISO(new Date())}
              dropdownMode='select'
              placeholder='MM/DD/YYYY'
              label='Start Date'
            />
          </div>
          <div className={'col-xs-6 col-sm-6'}>
            <Field
              name='end_date'
              type='tel'
              component={DateInputField}
              showYearDropdown
              maxDate={formatISO(new Date())}
              dropdownMode='select'
              placeholder='MM/DD/YYYY'
              label='End Date'
            />
          </div>
        </div>
        <div className={styles['download-container']}>
          <PrimaryButton type='submit' id='test-downloadcsv-submit' isLoading={submitting}>
            Download
          </PrimaryButton>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'downloadCSVForm',
  validate: downloadCSVValidate,
  touchOnBlur: false,
  // @ts-expect-error TS(2345): Argument of type 'typeof DownloadCSVForm' is not a... Remove this comment to see the full error message
})(DownloadCSVForm)
